module.exports = __webpack_public_path__ + "img/ic-bell.c51bb6c9.svg";